import React, { useEffect, useState } from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'
import API_CONSTANTS from '../api-constants'
import BoughtTickets from './ProfileContainer/BoughtTickets'
import GiftcardState from './ProfileContainer/GiftcardState'
import Membership from './ProfileContainer/Membership'
import NewsletterContainer from './ProfileContainer/NewsletterContainer'
import AdminProfile from './ProfileContainer/adminProfile'
import OrderedTickets from './ProfileContainer/OrderedTickets'


const Profile = ({ iframeId }) => {
    const history = useHistory();
    
    const [pageKey, setPageKey] = React.useState(sessionStorage.getItem('page_key') ? sessionStorage.getItem('page_key') :  "a");
    const left = document.getElementById('tes')?.getBoundingClientRect().x
    const key = sessionStorage.getItem('key')
    const [transactions, setTransactions] = useState()
    let page;
    switch (pageKey) {
        case 'a':
            page = <OrderedTickets leftMargin={left} setTransactions={setTransactions} />
            break;
        case 'b':
            page = <BoughtTickets leftMargin={left} transactions={transactions} />
            break;
        case 'c':
            page =<GiftcardState  /> 
            break;
        case 'd':
            page = <NewsletterContainer />
            break;
        case 'e':
            page = <Membership iframeId={iframeId} />
            break;
        case 'f':
            page = <AdminProfile setPageKey={setPageKey} />
            
    }

    useEffect(() => {
        sessionStorage.setItem('page_key', pageKey)
    }, [pageKey])

    

    useEffect(() => {
        fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/LoadProfile?key=${key}`, {
            method: "GET",
            headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                'Content-Type': 'application/x-www-form-urlencoded',
            },  
        })
            .then((res) => res.json())
            .then(result => {
               // console.log(result)
                if (result.result === 1) {
                  //  localStorage.setItem('key', result.key)
                    history.push('/profile', {
                        login_info: result.login,
                        transaction: result.transactionsPrYear[0],
                        newsgroup: result.Newsgroups,
                        reservations: result.Reservations,
                        memberships: result.Memberships,
                        key: result.key,
                        vouchers: result.Vouchers


                    })
                }
                
            }

            )
    }, [key])

    function logout() {
        fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/Logout?key=${key}`, {
            method: "GET",
            headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                'Content-Type': 'application/x-www-form-urlencoded',
            },  
        })
            .then((res) => res.json())
            .then(result => {
               // console.log(result, 'log out result')
                if (result.result === 1) {
                    sessionStorage.removeItem('key')
                    history.push('/login')
                    
                }
            })
    }
  
    return (
        <>
            { key ?
        <main>
            <header className='login_header'>
                <p className='profile'>Din profil</p>
                <button className='login_logout' onClick={logout}>Log ud</button>
           </header>

            <div className='ProfileContainer' id='tes'>
                <aside className='menu-container'>
                    <button style={{ borderBottom: pageKey === 'a' ? '3px solid white' : '' }} onClick={() => setPageKey('a')}>Bestilte Billetter</button>
                    <button style={{ borderBottom: pageKey === 'b' ? '3px solid white' : '' }} onClick={() => setPageKey('b')}>Købte Billetter</button>

                    <button style={{ borderBottom: pageKey === 'c' ? '3px solid white' : '' }} onClick={() => setPageKey('c')}>Gavekort & klippekort</button>
                    <button style={{ borderBottom: pageKey === 'd' ? '3px solid white' : '' }} onClick={() => setPageKey('d')}>Nyhedsbreve</button>
                    <button style={{ borderBottom: pageKey === 'e' ? '3px solid white' : '' }} onClick={() => setPageKey('e')}>Medlemsskaber</button>
                    <button style={{ borderBottom: pageKey === 'f' ? '3px solid white' : '' }} onClick={ () => setPageKey('f')}>Administrér profil</button>

                </aside>
                <section className='profile-description'>
                    {page}
                </section>
            </div>
          
                </main>
                : history.push('/login')
             }
        </>
    )
}

export default Profile